// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"dcf65e05","399":"3fac2f3c","448":"845662a3","501":"0f8bf633","610":"701acefc","778":"6e4e098f","842":"28e35cd3","964":"e4a4fc23"}[chunkId] + ".chunk.js";
};